import { getJumpConfig } from '@/api';
import { PAGE_URL } from '@/config';
import { HomeShowConfigItem } from '@/config/home-show-config';
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import { CustomException, util, windowHelper } from '@tencent/ppd-base-libs';
import { qryUserDefaultHk } from '@tencent/wphk-act-base-cgi';
import { cacheFunc, to } from '@tencent/wphk-base-utils';
import { handleMerchantJump, jumpMpRedirectPage } from './jump';

/** 检查当前用户钱包地区是否香港钱包 */
async function checkIsHKWallet(): Promise<boolean> {
  const [err, res] = await to(qryUserDefaultHk({}));
  if (err || !res) {
    new CustomException(err, 'checkIsHKWalletErr', '查询判断钱包地区接口失败');
    // 如果接口报错，就认为是香港钱包好了
    return true;
  }
  const { isDefaultHk } = res;
  return isDefaultHk === 1;
}

export const cacheCheckIsHKWallet = cacheFunc(checkIsHKWallet);

/** 获取特殊商户跳转到中转页的方法 */
export const checkAreaAndJumpHandle = async (config: HomeShowConfigItem, tools) => {
  // 查询钱包地区是否是香港
  const isDefaultHk = await cacheCheckIsHKWallet();
  if (!isDefaultHk) {
    const spId = config.spId || config.merchantId as string;
    handleMerchantJump(spId, tools.router);
    return { isContinue: false };
  }
  return { isContinue: true };
};

/** 获取配置的目标商户列表 */
export const getTargetSpIdList = cacheFunc(async () => {
  const configRes = await getJumpConfig();
  const walletConfig = configRes.configList.filter(item => item.isWalletJumpScene === '1');
  return walletConfig.map(item => item.merchantId);
});

/** 获取跟钱包相关的额外homeShow配置 */
export const getWalletExtraHomeShowConfig = async () => {
  try {
    const targetSpIdList = await getTargetSpIdList() || [];
    const targetConfig = targetSpIdList.map(spId => ({ spId, func: checkAreaAndJumpHandle }));
    return targetConfig;
  } catch (e) {
    new CustomException(e, 'getWalletHomeShowConfig', '获取钱包跳转逻辑失败');
    return [];
  }
};

/**
 * 获取跳转中转页商户白名单
 */
export const getRedirectWhiteListSpid = async (): Promise<string | undefined> => {
  const [err, targetSpIdList] = await to(getTargetSpIdList());
  const spId = getUrlParamByKey(UrlParamKey.spId);
  if (err || !spId) {
    return undefined;
  }
  return targetSpIdList.find(item => item === spId);
};

/** 根据spid处理非香港钱包用户跳转 */
export const handleNotHKUserJump = (spid) => {
  try {
    // 如果是在小程序中就跳转到小程序中转页
    if (util.isInMiniProgram()) {
      return jumpMpRedirectPage(spid);
    }
    windowHelper.replace(`${PAGE_URL}?spId=${spid}&isNotHkUser=1&page=thirdmpredirect`);
  } catch (e) {
    new CustomException(e, 'handleNotHKUserJumpFail', '非香港钱包用户跳转失败');
  }
};
